
angular.module('olivioConfiguratorApp')
  .factory('DesignCtrlService', function ($rootScope, Model, Data, OLIVIOMainFactory, StepService, ColorSelectService, AdvancedLoginService, Storage, $window, $location) {
    // there'll never be more than 8 lums, so we can speed up lum type change by using this constant arrays
    var lumTypesAllPiccolo = [OLIVIO.LUM_PICCOLO, OLIVIO.LUM_PICCOLO,OLIVIO.LUM_PICCOLO,OLIVIO.LUM_PICCOLO,OLIVIO.LUM_PICCOLO, OLIVIO.LUM_PICCOLO,OLIVIO.LUM_PICCOLO,OLIVIO.LUM_PICCOLO];
    var lumTypesAllMedio = [OLIVIO.LUM_MEDIO, OLIVIO.LUM_MEDIO,OLIVIO.LUM_MEDIO,OLIVIO.LUM_MEDIO,OLIVIO.LUM_MEDIO, OLIVIO.LUM_MEDIO,OLIVIO.LUM_MEDIO,OLIVIO.LUM_MEDIO];
    var lumTypesAllGrande = [OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE,OLIVIO.LUM_GRANDE,OLIVIO.LUM_GRANDE,OLIVIO.LUM_GRANDE, OLIVIO.LUM_GRANDE,OLIVIO.LUM_GRANDE,OLIVIO.LUM_GRANDE];

    var ctrlService = {
      advancedEditingLumId: -1,

      // will be set by DesignCtrl
      bracketSelectorSetup: null,
      lumTypeSelectorSetup: null,
      /**
       * This is to replace all calls To OLIVIO.cmodel.setLumType(type);
       * never called as advanced action for single head TODO maybe call this for single heads too, to unify code paths
       */
      setLumTypeAndUpdateModel: function(type) {
        // globaler Wert. benutzt von Candelabra
        OLIVIO.cmodel.lumType = type;
        // setzt cmodel
        OLIVIO.cmodel.setLumTypes(type === OLIVIO.LUM_MEDIO ? lumTypesAllMedio : (type === OLIVIO.LUM_PICCOLO ? lumTypesAllPiccolo : lumTypesAllGrande),
          Model.goboAllowed() ? Model.model.gobo.individual : []);
        console.log('DesignCtrlService.setLumTypeAndUpdateModel: '+ type === OLIVIO.LUM_MEDIO ? lumTypesAllMedio : (type === OLIVIO.LUM_PICCOLO ? lumTypesAllPiccolo : lumTypesAllGrande), Model.goboAllowed() ? Model.model.gobo.individual : []);
        // schreibt vom cmodel ins Model
        OLIVIO.cmodel.updateModelWithIndividualValues(Model.model);
      },
      getIndexForBeamType: function (id) {
        for (var i = 0; i < Data.bracketOptions.length; i++) {
          if (Data.bracketOptions[i].id === id) {
            return i;
          }
        }
        return 0;
      },
      updateLumOptions: function() {
        ctrlService.lumOptions = Data.getLumOptionsForProduct(Model.model.product.id);
        console.log('DesignService updateLumOptions:', ctrlService.lumOptions, Data.lumOptions);
      },
      getIndexForLumType: function (id) {
        for (var i = 0; i < ctrlService.lumOptions.length; i++) {
          if (ctrlService.lumOptions[i].id === id) {
            return i;
          }
        }
        return 0;
      },
      /** take data from later steps if the user did come back to design having set values there */
      ensureLumData: function() {
        for (var i = 0; i < Model.model.design.lumcount; i++) {
          //console.log('ensureLumData '+i+':', Model.model.assembly.individual[i], Model.model.design.individualRotations[i]);

          if(Model.model.assembly.id !== '' && Model.model.assembly.individual[i] === undefined)
            Model.model.assembly.individual[i] = Model.model.assembly.id;
          if(Model.model.distribution.id !== '' && Model.model.distribution.individual[i] === undefined)
            Model.model.distribution.individual[i] = Model.model.distribution.id;
          // gobo is built for holes in the array, no need to update
          if(Model.model.color.id !== '' && Model.model.color.individual[i] === undefined)
            Model.model.color.individual[i] = Model.model.color.id;
          if(Model.model.power.id !== '' && Model.model.power.individual[i] === undefined)
            Model.model.power.individual[i] = Model.model.power.id;
        }
      },
      colorwheel: function () {
        ColorSelectService.show();
      },
      toggleAdvanced: function () {
        AdvancedLoginService.toggle();
      },
      changeLumType: function(type) {
        var lumType = Data.getLumOption(type);

        console.log('changeLumType', Model.model.design.lumtype, type, Model.model.design.lumtype !== type);

        if (lumType && Model.model.design.lumtype !== type) {
          if (Model.model.design.lumtype === OLIVIO.LUM_GRANDE && !Model.model.userOptions.advanced === true) {
            // da bei Sistema prinzipiell auch das mischen unterschiedlicher Kopfgrößen erlaubt ist, muss hier (und nur hier) in design.js beim Umschalten weg von grande die Gobo-Liste gelöscht werden, um das mischen zu deaktivieren
            Model.model.gobo.individual = [];
            StepService.getStep('gobo').skipped = true;
          }
          Model.model.design.lumtype = type;
          if (type === OLIVIO.LUM_PICCOLO && Model.model.design.beamtype !== OLIVIO.BRACKET_SISTEMA3) {
            // ggf bracketType setzen
            console.log('v== changing bracket for piccolo ');
            if (this.bracketSelectorSetup && !this.bracketSelectorSetup.blockcallback) {
              this.bracketSelectorSetup.blockcallback = true;
              this.bracketSelectorSetup.goto(this.getIndexForBeamType(OLIVIO.BRACKET_SISTEMA3) + 1);
            }
            this.changeBracket(OLIVIO.BRACKET_SISTEMA3, true);
            console.log('^== changed bracket for piccolo ');
          }
          this.setLumTypeAndUpdateModel(type);
          Model.resetAssembly();
          StepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = false;
          StepService.updateEnabled();
        }
      },
      /**
       * change used bracket
       * @param type          new bracked type id
       * @param skipLumCheck  true: changeBracket is called while changing the lum (ie went to piccolo) so do not check the lum again.
       */
      changeBracket: function(type, skipLumCheck) {
        console.log('v- changeBracket ' + type, skipLumCheck ? 'skipLumCheck' : '');
        // FIXME unnötig kompiziert

        // betrifft nur piccolo, weil alle anderen überall passen
        if (!skipLumCheck) {
          var bracketOption = Data.getBracketOption(type);
          var invalidLumOption = false;
          if (!Data.isLumAllowedForBracket(bracketOption, Model.model.design.lumtype)) {
            var lumtype = bracketOption.attachablelums[0];
            console.log('+- replacing default lum with from : ' + Model.model.design.lumtype, ' to ', lumtype + '=' + ctrlService.lumOptions[this.getIndexForLumType(lumtype)].id);
            Model.model.design.lumtype = ctrlService.lumOptions[this.getIndexForLumType(lumtype)].id;
            this.lumTypeSelectorSetup.goto(this.getIndexForLumType(Model.model.design.lumtype) + 1);
            invalidLumOption = true;
          }
          // look if a single selected lum is doesn't fit
          if (!invalidLumOption) {
            for (var i = Model.model.design.individualHeads.length - 1; i >= 0; i--) {
              var head = Model.model.design.individualHeads[i];
              console.log('+- changeBracket: lum ' + i + ':', head, Data.isLumAllowedForBracket(bracketOption, head));
              if (Data.isLumAllowedForBracket(bracketOption, head) === false) {
                if (Model.model.gobo.individual && Model.model.gobo.individual[i]) {
                  Model.model.design.individualHeads[i] = OLIVIO.LUM_GRANDE; // gobo true -> i is a grade despite the piccolo in the data, just change this to make it fit.
                  continue;
                } else {
                  invalidLumOption = true;
                  break;
                }
              }
            }
          }
          if (invalidLumOption) {
            console.log('+- replacing all installed lums with : ' + lumtype + '===' + Model.model.design.lumtype);
            this.setLumTypeAndUpdateModel(Model.model.design.lumtype);
          }
        }

        OLIVIO.cmodel.setBracketType(type);
        Model.model.design.beamtype = type;
        Data.applyLumConstraints(Model.model);
        console.log('^- changeBracket '+type);
      }
    };

    return ctrlService;
  })
  .controller('DesignCtrl', function ($rootScope, $scope, Model, Data, DesignCtrlService, OLIVIOMainFactory, StepService, ColorSelectService, AdvancedLoginService, Storage, $window, $location) {
    console.log('v---- init DesignCtrl '+Model.model.design.lumcount+' lums '+Model.model.design.lumtype);

    $scope.OLIVIO = OLIVIO;
    $scope.data = Data;
    $scope.model = Model.model;
    $scope.cmodel = OLIVIO.cmodel;
    $scope.service = DesignCtrlService;

    $scope.model.design.gobo = false; // never open #design with gobo list open ie. reset state when switching step
    StepService.getStep('gobo').skipped = !Model.haveGobo(); // initiate value. it will be change when Gobos are added or removed

    // TODO use this for showing rotation and height input in advanced mode
    $scope.advancedEditingModelIndex = 0;
    $scope.advancedEditingLumDegree = 0;
    $scope.advancedEditingLumHeight = 0;
    $scope.advancedLumHeightMenuYPos = 57;

    $scope.visibleLums = [];

    $scope.advancedRotationChangeTimeout = null;
    $scope.advancedLumHeightChangeTimeout = null;


    $scope.intRegex = /^\d+$/;

    $scope.bracketOptions = Data.bracketOptions;

    $scope.data.applyLumConstraints($scope.model);
    DesignCtrlService.updateLumOptions();

    $scope.individualLumRotations = [];
    var updateIndividualLumDegreesFromModel = function() {
      $scope.individualLumRotations = [];
      for(var i=0;i<=$scope.model.design.individualRotations.length;i++) {
        $scope.individualLumRotations[i] = (360-$scope.model.design.individualRotations[i])%360;
      }
    };
    updateIndividualLumDegreesFromModel();

    $scope.bracketSelectorSetup = {
      start: (DesignCtrlService.getIndexForBeamType($scope.model.design.beamtype) + 1),
      width: 150,
      height: 268,
      navigation: false,
      blockcallback: false,
      callback: {
        loaded: function (number) {
        },
        start: function (number) {
        },
        complete: function (number) {
          $scope.selectBracketType($scope.bracketOptions[number - 1].id);
          //$scope.model.design.beamtype = ();
        }
      },
      goto: function (number) {
        // will be replaced by real goto during execution of .directive('sliderjs')
      }
    };
    DesignCtrlService.bracketSelectorSetup = $scope.bracketSelectorSetup;

    $scope.lumTypeSelectorSetup = {
      start: (DesignCtrlService.getIndexForLumType($scope.model.design.lumtype) + 1),
      width: 150,
      height: 268,
      navigation: false,
      blockcallback: false,
      callback: {
        loaded: function (number) {
        },
        start: function (number) {
          // Achtung: number ist der alte Index, der verlassen wird. der zukünftige/die Richtung wird verschwiegen
        },
        complete: function (number) {
          console.log('lumTypeSelectorSetup complete', number, DesignCtrlService.lumOptions[number - 1].id, $scope.lumTypeSelectorSetup.blockcallback ? 'callback blocked' : 'callback not blocked');
          $scope.selectLumType(DesignCtrlService.lumOptions[number - 1].id);
        }
      },
      goto: function (number) {
        console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX unreplaced goto');
        // will be replaced by real goto during execution of .directive('sliderjs')
      }
    };
    DesignCtrlService.lumTypeSelectorSetup = $scope.lumTypeSelectorSetup;


    $scope.jsLoaded = false;

    $scope.createSVG = function () {
      console.log('v-------- createSVG', OLIVIO.cmodel);
      $scope.main = OLIVIOMainFactory.create($scope);

      OLIVIO.cmodel.setAngularCallback($scope.updateFromSVG);
      $scope.main.updateViewBoxes();
      //$scope.main.pole.updateHeight();

      $scope.main.setEditAdvanced($scope.model.userOptions.advanced);

      if ($scope.model.userOptions.advanced === false) {
        $scope.main.editLums();
      }

      $scope.updateVisibleLums();

      $scope.jsLoaded = true;

      console.log('^-------- createSVG', OLIVIO.cmodel);
    };

    $scope.$on('$viewContentLoaded', function () {

      console.log('DesignCtrl on $viewContentLoaded', OLIVIO.cmodel.mastSizesmm);

      $scope.createSVG();

      $scope.$watch('model.design.lumtype', function(nV, oV) {
        console.log('WATCH model.design.lumtype (neu)', $scope.model.design.lumtype, DesignCtrlService.getIndexForLumType($scope.model.design.lumtype), $scope.lumTypeSelectorSetup.goto);
        if($scope.model.design.lumtype !== OLIVIO.LUM_GRANDE) {
          $scope.model.design.gobo = false; // das ist nur die Darstellung der Gobo-Auswahl, die wird bei medio deaktiviert
        }
      });

      $scope.$watch('model.design.individualRotations', updateIndividualLumDegreesFromModel);
      $scope.$watch('service.advancedEditingLumId', function (newValue, oldValue) {
        console.log('WATCH service.advancedEditingLumId', $scope.service.advancedEditingLumId > -1,  $scope.service.advancedEditingLumId, $scope.model.design.individualHeads);
        updateIndividualLumDegreesFromModel();

        if ($scope.service.advancedEditingLumId > -1) {
          $scope.advancedEditingModelIndex = OLIVIO.cmodel.getModelIndexForLum($scope.service.advancedEditingLumId);
          $scope.advancedEditingLumDegree = $scope.model.design.individualRotations[$scope.advancedEditingModelIndex];
          $scope.advancedEditingLumHeight = $scope.model.design.individualHeights[$scope.advancedEditingModelIndex];
        } else {
          $scope.advancedLumHeightMenuYPos = 50;
          $scope.advancedEditingLumDegree = 0;
          $scope.advancedEditingLumHeight = 0;
        }
      }, true);

      $scope.$watch('model.design.colorIds', function (newValue, oldValue) {
        if (newValue) {
          OLIVIO.cmodel.setColors(
            $scope.data.getColorSelectOption($scope.model.design.colorIds.mast).color,
            $scope.data.getColorSelectOption($scope.model.design.colorIds.lumiere).color,
            $scope.data.getColorSelectOption($scope.model.design.colorIds.inlay).color,
            $scope.data.getColorSelectOption($scope.model.design.colorIds.mast).colorOutline,
            $scope.data.getColorSelectOption($scope.model.design.colorIds.lumiere).colorOutline,
            $scope.data.getColorSelectOption($scope.model.design.colorIds.inlay).colorOutline
          );
        }
      }, true);

      //$scope.$watch('model.design.lumcount', function () { $scope.updateVisibleLums() }); // -- scheint nicht mehr nötig

      /*
       $scope.$watch('advancedEditingLumHeight', function (newValue, oldValue) {

       if ($scope.service.advancedEditingLumId > -1) {

       $scope.advancedLumHeightMenuYPos = 47 + Math.round(OLIVIO.cmodel.getJointPositionWorldOfLum($scope.service.advancedEditingLumId)/$scope.main.getPixelFactorSide());
       //getJointPositionWorldOfLum
       }
       }, true);*/


    });

    $scope.$on('$destroy', function () {
      DesignCtrlService.bracketSelectorSetup = null;
      DesignCtrlService.lumTypeSelectorSetup = null;
      $scope.main = null;
      $scope.jsLoaded = false; // TODO .jsLoaded is not really used anymore. check and remove it.

      OLIVIOMainFactory.destroy();
    });


    $scope.updateFromSVG = function () {
      //console.log('vv-- updateFromSVG $scope.model.design.lumcount '+$scope.model.design.lumcount+' => ' + OLIVIO.cmodel.currentLumCount );
      $scope.model.design.height = OLIVIO.cmodel.mastSizesmm[OLIVIO.cmodel.mastSizeIndex];
      $scope.model.design.diameter = OLIVIO.cmodel.mastDiametermm[OLIVIO.cmodel.mastSizeIndex];
      $scope.model.design.startDegree = Math.round(OLIVIO.cmodel.getStartRotationMathematical());
      $scope.model.design.lumcount = OLIVIO.cmodel.currentLumCount;
      $scope.model.design.topToBottomRotation = OLIVIO.cmodel.getTopToBottomRotation();
      $scope.model.design.topToBottomRotationCW = OLIVIO.cmodel.getTopToBottomRotationCW();
      $scope.model.design.toplumiereheight = Math.round(OLIVIO.cmodel.getTopLumPosmm());
      $scope.model.design.bottomlumiereheight = Math.round(OLIVIO.cmodel.getBottomLumPosmm());

      OLIVIO.cmodel.updateModelWithIndividualValues($scope.model);

      if ($scope.service.advancedEditingLumId > -1) {
        $scope.advancedEditingModelIndex = OLIVIO.cmodel.getModelIndexForLum($scope.service.advancedEditingLumId);
        //console.log('++-- updateFromSVG: $scope.service.advancedEditingLumId > -1', $scope.service.advancedEditingLumId, $scope.advancedEditingModelIndex );
        $scope.advancedEditingLumDegree = $scope.model.design.individualRotations[$scope.advancedEditingModelIndex];
        $scope.advancedEditingLumHeight = $scope.model.design.individualHeights[$scope.advancedEditingModelIndex];
      }
      // basic editing: copy heights/rotations to individual lums
      /*
       // TODO advanced editing -> do not copy
       var heightOffset = ($scope.model.design.toplumiereheight - $scope.model.design.bottomlumiereheight) / ($scope.model.design.lumcount - 1);
       var rotationOffset = ($scope.model.design.topToBottomRotation - 0) / ($scope.model.design.lumcount - 1);

       $scope.model.design.individualHeights = new Array($scope.model.design.lumcount);
       $scope.model.design.individualRotations = new Array($scope.model.design.lumcount);

       for (var i = 0; i < $scope.model.design.lumcount; i++) {
       $scope.model.design.individualHeights[i] = Math.round($scope.model.design.toplumiereheight - heightOffset * i);
       $scope.model.design.individualRotations[i] = Math.round(0 + rotationOffset * i);
       }
       */

      $scope.updateVisibleLums(); //!h weil updateFromSVG als im cmodel als angular-Handler gesetzt ist TODO remove data multiplication in Model, cmodel and Olivio_main

      if ($scope.jsLoaded === true && $scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
        $scope.$apply();
      } else {
        //console.log('++-- updateFromSVG: angular is already digesting... :(');
      }
      //console.log('^^-- updateFromSVG ');
    };

    $scope.toggleAlignment = function () {
      OLIVIO.cmodel.setTopToBottomRotationClockwise(!OLIVIO.cmodel.getTopToBottomRotationCW());
    };


    $scope.rotate360 = function () {
      if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) {
        OLIVIO.cmodel.setCandelabraRotation(OLIVIO.cmodel.candelabraRotation + 5);
      } else {
        if (OLIVIO.cmodel.advancedMode === true) {
          OLIVIO.cmodel.setLumRotationsCombined(5);
        } else {
          OLIVIO.cmodel.setStartRotation(OLIVIO.cmodel.startRotation + 5, false);
        }

      }
      //OLIVIO.cmodel.setCandelabraRotation(OLIVIO.cmodel.candelabraRotation + 5);
    };


    $scope.rotate360down = function () {
      $scope.main.setRotationActive(true);
    };


    $scope.addLum = function () {
      //console.log('v- addLum');
      if ($scope.model.design.lumcount < 8) {
        $scope.model.design.lumcount++;
        DesignCtrlService.ensureLumData();
        OLIVIO.cmodel.setLumCount($scope.model.design.lumcount);
        OLIVIO.cmodel.updateModelWithIndividualValues($scope.model);
        $scope.updateVisibleLums();
      }
      //console.log('^- addLum');
    };

    $scope.removeLum = function () {
      if ($scope.model.design.lumcount > 1) {
        $scope.model.design.lumcount--;
        OLIVIO.cmodel.setLumCount($scope.model.design.lumcount);
        OLIVIO.cmodel.updateModelWithIndividualValues($scope.model);
        $scope.updateVisibleLums();
        //console.log('removeLum ', $scope.model.design.lumcount, $scope.model.design.lumcount === parseInt($scope.model.design.lumcount));
      }
    };

    // medio wird nicht gesperrt. Model.goboAllowed() sagt ob Gobo grundsätzlich erlaubt ist, also  (grande || !Candelabra)
    // TODO Model.goboAllowed() im Datasheet berücksichtigen
    $scope.setGoboMode = function(show) {

      $scope.model.design.gobo = show;

      if ($scope.jsLoaded) {

        if (show && !$scope.model.design.goboDone) {
          // $scope.model.design.goboDone will be set by Info-Dialog
          var foundGobo = false;
          if ($scope.model.gobo.individual.length < $scope.model.design.lumcount) { // müsste immer in den else Zweig, außer bei geladenen alten Konfigurationen
            var individual = new Array($scope.model.design.lumcount);
            var individualType = new Array($scope.model.design.lumcount);
            for(var i = 0 ; i < $scope.model.gobo.individual.length; i++) {
              individual[i] = $scope.model.gobo.individual[i];
              individualType[i] = $scope.model.gobo.individualType[i];
              if(individual[i])
                foundGobo = true;
            }
            $scope.model.gobo.individual = individual;
            $scope.model.gobo.individualType = individualType;
          } else {
            for (var i = 0; i < $scope.model.design.lumcount; i++) {
              if ($scope.model.gobo.individual[i]) {
                foundGobo = true;
                break;
              }
            }
          }
          if (!foundGobo) {
            $scope.model.gobo.done = false;
            $scope.model.gobo.id = null;
            $scope.model.gobo.individual[0] = true;
            $scope.model.gobo.individualType[0] = Data.goboOptions[2].id;
          }
          StepService.getStep('gobo').skipped = false; // if we didn't find a gobo we've added one just above
          StepService.updateEnabled();
        }

        OLIVIO.cmodel.setLumTypes($scope.model.design.individualHeads, Model.goboAllowed() ? $scope.model.gobo.individual : []);
      }
    };

    $scope.toggleGobo = function(index) {
      $scope.model.gobo.individual[index] = !$scope.model.gobo.individual[index];

      if($scope.model.gobo.individual[index]) {
        if(!$scope.model.gobo.individualType[index] || $scope.model.gobo.individualType[index] === '' ) {
          // set type if step #gobo has been done before returning to step #design
          $scope.model.gobo.individualType[index] = $scope.model.gobo.id;
        }
        StepService.getStep('gobo').skipped = false;
      } else {
        StepService.getStep('gobo').skipped = !Model.haveGobo();
      }
    };

    $scope.goboInfoOk = function() {
      $scope.model.design.goboDone = true; // TODO design.goboDone data.js check, reset and default
      $scope.model.design.goboInfo = false; // TODO design.goboInfo data.js always set to false
    };


    $scope.selectLumType = function (type) {
      if ($scope.lumTypeSelectorSetup.blockcallback === true) {
        console.log('selectLumType blocked', type);
        $scope.lumTypeSelectorSetup.blockcallback = false;
        return;
      }

      DesignCtrlService.changeLumType(type);

      if ($scope.jsLoaded === true && $scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
        $scope.$apply();
      }


    };

    // für den Slider
    $scope.selectBracketType = function (type) {
      if ($scope.bracketSelectorSetup.blockcallback === true) {
        $scope.bracketSelectorSetup.blockcallback = false;
        return;
      }
      DesignCtrlService.changeBracket(type);
      if ($scope.jsLoaded === true && $scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
        $scope.$apply();
      }
    };


    // text input field handler
    $scope.advancedDegreeUpdate = function () {
      //console.log('advancedDegreeUpdate ---');
      console.log('advancedDegreeUpdate '+$scope.advancedEditingLumId+' ',$scope.individualLumRotations, $scope.model.design.individualRotations,$scope.model.design.individualHeights);
      clearTimeout($scope.advancedRotationChangeTimeout);
      if ($scope.intRegex.test($scope.advancedEditingLumDegree)) {
        //OLIVIO.cmodel.setStartRotationMathematical($scope.model.design.startDegree);
        //$scope.advancedEditingLumDegree = $scope.model.design.individualRotations[$scope.advancedEditingModelIndex];
        $scope.advancedEditingModelIndex = OLIVIO.cmodel.getModelIndexForLum($scope.service.advancedEditingLumId);
        $scope.model.design.individualRotations[$scope.advancedEditingModelIndex] = (360-$scope.individualLumRotations[$scope.advancedEditingModelIndex])%360;
        $scope.advancedEditingLumDegree = $scope.model.design.individualRotations[$scope.advancedEditingModelIndex];
        OLIVIO.cmodel.setSingleLumRotationAdvancedMathematical($scope.individualLumRotations[$scope.advancedEditingModelIndex], $scope.service.advancedEditingLumId, true);
        //console.log('advancedDegreeUpdate '+$scope.service.advancedEditingLumId, $scope.model.design.individualRotations[$scope.advancedEditingModelIndex]);
        //console.log('should change angle of: '+$scope.service.advancedEditingLumId);
      } else {
        //$scope.updateFromSVG();
      }
    };

    $scope.advancedDegreeChange = function () {
      clearTimeout($scope.advancedRotationChangeTimeout);
      $scope.advancedRotationChangeTimeout = setTimeout($scope.advancedDegreeUpdate, 1500);
    };

    $scope.advancedHeightUpdate = function () {
      //console.log('advancedHeightUpdate ---');
      //console.log('advancedHeightUpdate '+$scope.advancedEditingLumId+' '+$scope.model.design.individualHeights);
      clearTimeout($scope.advancedLumHeightChangeTimeout);
      $scope.advancedLumHeightChangeTimeout = null;
      if ($scope.intRegex.test($scope.advancedEditingLumHeight)) {
        $scope.advancedEditingModelIndex = OLIVIO.cmodel.getModelIndexForLum($scope.service.advancedEditingLumId);
        $scope.advancedEditingLumHeight = $scope.model.design.individualHeights[$scope.advancedEditingModelIndex];
        OLIVIO.cmodel.setSingleLumHeightBymm($scope.advancedEditingLumHeight, $scope.service.advancedEditingLumId, true);

        //OLIVIO.cmodel.setStartRotationMathematical($scope.model.design.startDegree);
        //$scope.advancedEditingLumHeight = $scope.model.design.individualHeights[$scope.advancedEditingModelIndex];
        //console.log('should change height of: '+$scope.advancedEditingLumId);
        //console.log('advancedHeightUpdate '+$scope.advancedEditingLumId+' '+$scope.model.design.individualHeights);
      } else {
        //$scope.updateFromSVG();
      }
    };

    $scope.advancedHeightChange = function () {
      //console.log('advancedHeightChange');
      clearTimeout($scope.advancedLumHeightChangeTimeout);
      $scope.advancedLumHeightChangeTimeout = null;
      $scope.advancedLumHeightChangeTimeout = setTimeout($scope.advancedHeightUpdate, 1500);
    };

    $scope.updateVisibleLums = function () {
      console.log("v-- updateVisibleLums "+OLIVIO.cmodel.getLumieres().length);
      $scope.visibleLums = [];
      var modelIndex = 0;
      for (var i = 0; i < OLIVIO.cmodel.getLumieres().length; i++) {
        var lum = OLIVIO.cmodel.getLumieres()[i];
        console.log('+-- updateVisibleLums'+ i+'("'+lum.modelIndex+'"): ',lum.lumVisible);
        if (lum.lumVisible === true) {
          var vislum = {
            index: i,
            modelIndex: modelIndex,
            number: modelIndex + 1,
            selected: (i === $scope.service.advancedEditingLumId)
          };
          modelIndex++;
          $scope.visibleLums.push(vislum);
        }
      }
      console.log("^-- updateVisibleLums "+$scope.visibleLums.length+"/"+OLIVIO.cmodel.getLumieres().length);
    };

    // this handels the focus event into the text fields but is called from olivo_* too
    // this is bad code, as it handles both fields of the lum, height and angle  and does calculation. Receiving the focus should not lead to calculations and possible changing data
    $scope.setAdvancedEditingLumId = function (id) {
      console.log('v---- setAdvancedEditingLumId: '+id);

      //console.log('setAdvancedEditingLumId ---');
      //console.log('setAdvancedEditingLumId timeout '+$scope.advancedLumHeightChangeTimeout);

      if ($scope.service.advancedEditingLumId > -1 && $scope.advancedLumHeightChangeTimeout !== null) {
        console.log('+---- setAdvancedEditingLumId writing from model to cmodel');
        clearTimeout($scope.advancedLumHeightChangeTimeout);
        $scope.advancedLumHeightChangeTimeout = null;
        //OLIVIO.cmodel.updateLumBoundariesAdvanced(); // FIXME ?
        var aInd = $scope.service.advancedEditingLumId;
        var moInd = OLIVIO.cmodel.getModelIndexForLum(aInd);
        var nuRot = $scope.model.design.individualRotations[moInd];
        var nuHi = $scope.model.design.individualHeights[moInd];

        if ($scope.intRegex.test(nuRot)) {
          OLIVIO.cmodel.setSingleLumRotationAdvancedMathematical(nuRot, aInd, false);
        }
        if ($scope.intRegex.test(nuHi)) {
          OLIVIO.cmodel.setSingleLumHeightBymm(nuHi, aInd, true);
        }
        // reading back calculated values
        $scope.updateFromSVG();
      }
      //console.log('setAdvancedEditingLumId '+$scope.advancedEditingLumId+' '+$scope.model.design.individualHeights);
      OLIVIO.cmodel.updateLumBoundariesAdvanced();
      $scope.service.advancedEditingLumId = id;
      $scope.main.setAdvancedSelection(id);
      $scope.updateVisibleLums(); // TODO this is sometimes done twice as it get's called from updateFromSVG now.
      console.log('^----setAdvancedEditingLumId '+$scope.advancedEditingLumId+' '+$scope.model.design.individualHeights);
    };

    console.log('+---- init DesignCtrl '+Model.model.design.lumcount+' lums '+Model.model.design.lumtype);
    (function () {  // init

      // sofort bei aufruf startoptionen festlegen, sofern noch nicht festgelegt
      if ($scope.model.product.id === OLIVIO.PRODUCT_FLORACION || $scope.model.design.lumtype === '') {
        $scope.model.design.lumtype = OLIVIO.LUM_GRANDE; // floracion erlaubt nur grande, grande ist auch default bei allen anderen
      }

      if ($scope.model.design.beamtype === '') {
        $scope.model.design.beamtype = OLIVIO.BRACKET_SISTEMA1;
      }

      //console.log($scope.model.design.beamtype);
      $scope.model.design.done = true;
      StepService.updateEnabled();

    })();

    console.log('^---- init DesignCtrl '+Model.model.design.lumcount+' lums '+Model.model.design.lumtype);
  });
